// test796
(796 && 0);
